export enum AssessmentType {
  MULTIPLE_CHOICE = 'Multiple Choice',
  TRUE_OR_FALSE = 'True or False',
  FILL_IN_THE_BLANKS = 'Fill in the blanks',
  SHORT_ANSWER = 'Short Answer',
}